import { useState } from 'react';
import NavMenu from './NavMenu';
import '../styles/Navbar.css';

/**
 * Fixed top navigation.
 * - Logo (left)
 * - "THE PLATFORM" pill button + hamburger toggle (right)
 * - Hamburger opens <NavMenu />, a full menu overlay/panel
 *
 * Drop this in once, above your scrolling sections, e.g.:
 *   <Navbar />
 *   <main className="scroll-sections">...</main>
 */
export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <>
      <header className="navbar">
        <a href="#home" className="navbar__logo" onClick={() => setMenuOpen(false)}>
          <img src="/images/botify.jpg" alt="Botify" className="navbar__logo-icon" />
          <span>Botify</span>
        </a>

        <div className="navbar__right">
          <a
            href="https://app.botify.cloud"
            target="_blank"
            rel="noopener noreferrer"
            className="navbar__platform-btn"
          >
            THE PLATFORM
          </a>

          <button
            type="button"
            className={`navbar__hamburger ${menuOpen ? 'is-open' : ''}`}
            aria-label={menuOpen ? 'Close menu' : 'Open menu'}
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((v) => !v)}
          >
            <span className="navbar__hamburger-line" />
            <span className="navbar__hamburger-line" />
          </button>
        </div>
      </header>

      <NavMenu isOpen={menuOpen} onClose={() => setMenuOpen(false)} />
    </>
  );
}